"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { installAnalyticsUnloadFlush, trackPageView } from "@/lib/analytics-client"

/** Installs consent-gated page-view/time-on-page tracking and records
 * route changes. Does nothing at all unless the visitor has accepted
 * cookies. See lib/analytics-client.ts. */
export function AnalyticsTracker() {
  const pathname = usePathname()

  useEffect(() => {
    installAnalyticsUnloadFlush()
  }, [])

  useEffect(() => {
    if (pathname) trackPageView(pathname)
  }, [pathname])

  return null
}
